import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

// Mappa "id card" → categoria menu corrispondente (per lo scroll)
const dishes = [
  {
    id: "ramen",
    menuCat: "ramen",
    name: "Ramen",
    desc: "Brodo tonkotsu bollito 24h, noodles freschi, chashu e uovo ajitama.",
    img: "https://images.unsplash.com/photo-1612927601601-6638404737ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxyYW1lbiUyMGJvd2wlMjBkYXJrJTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzg0MDM1NjEyfDA&ixlib=rb-4.1.0&q=85",
    tag: "Signature",
  },
  {
    id: "antipasti",
    menuCat: "antipasti",
    name: "Antipasti",
    desc: "Gyoza fatti a mano, edamame al sale marino, involtini primavera croccanti.",
    img: "https://images.unsplash.com/photo-1581691762051-3af0c56106df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxhc2lhbiUyMGFwcGV0aXplcnMlMjBkYXJrfGVufDB8fHx8MTc4NDAzNTYyMXww&ixlib=rb-4.1.0&q=85",
    tag: "Da condividere",
  },
  {
    id: "cinesi",
    menuCat: "primi",
    name: "Piatti Cinesi",
    desc: "Wok tradizionale, spaghetti di riso, manzo al pepe di Sichuan.",
    img: "https://images.unsplash.com/photo-1523905330026-b8bd1f5f320e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxjaGluZXNlJTIwZGlzaCUyMGRhcmslMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODQwMzU2MjJ8MA&ixlib=rb-4.1.0&q=85",
    tag: "Wok",
  },
  {
    id: "coreani",
    menuCat: "carne",
    name: "Piatti Coreani",
    desc: "Bibimbap con verdure croccanti, bulgogi marinato, kimchi artigianale.",
    img: "https://images.unsplash.com/photo-1498654896293-37aacf113fd9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxrb3JlYW4lMjBmb29kJTIwZGFya3xlbnwwfHx8fDE3ODQwMzU2MjF8MA&ixlib=rb-4.1.0&q=85",
    tag: "Piccante",
  },
  {
    id: "estive",
    menuCat: "spiedini",
    name: "Spiedini",
    desc: "Kabob alla brace, ali di pollo arrosto, spiedini di manzo e agnello.",
    img: "https://images.unsplash.com/photo-1592093221246-0807035b6064?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxhc2lhbiUyMGFwcGV0aXplcnMlMjBkYXJrfGVufDB8fHx8MTc4NDAzNTYyMXww&ixlib=rb-4.1.0&q=85",
    tag: "Alla griglia",
  },
  {
    id: "dolci",
    menuCat: "bevande",
    name: "Bevande & Dolci",
    desc: "Bubble tea al taro, mango pomelo sago, tè al latte jasmine.",
    img: "https://images.unsplash.com/photo-1637944220604-c5f28faac604?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxhc2lhbiUyMGRlc3NlcnQlMjBkYXJrfGVufDB8fHx8MTc4NDAzNTYyMXww&ixlib=rb-4.1.0&q=85",
    tag: "Bubble tea",
  },
];

const scrollToMenuCat = (menuCatId) => {
  // Scroll to menu section first, then to specific category
  const cat = document.getElementById(`cat-${menuCatId}`);
  if (cat) {
    const y = cat.getBoundingClientRect().top + window.scrollY - 140;
    window.scrollTo({ top: y, behavior: "smooth" });
  } else {
    const menu = document.getElementById("menu");
    if (menu) menu.scrollIntoView({ behavior: "smooth" });
  }
};

export default function DishesSection() {
  return (
    <section id="piatti" data-testid="dishes-section" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-20">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="text-xs uppercase tracking-[0.32em] text-gold font-medium">Le Categorie</span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] max-w-2xl"
              data-testid="dishes-title"
            >
              Sei mondi, un solo <span className="text-ember">tavolo</span>.
            </motion.h2>
          </div>
          <p className="text-white/60 max-w-md text-base md:text-lg leading-relaxed">
            Tocca una categoria per esplorare i piatti e ordinare direttamente dal menu.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {dishes.map((dish, i) => (
            <motion.button
              key={dish.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: "easeOut" }}
              onClick={() => scrollToMenuCat(dish.menuCat)}
              className="group relative overflow-hidden rounded-3xl bg-ash border border-white/5 hover:border-gold/40 transition-colors duration-500 text-left"
              data-testid={`dish-card-${dish.id}`}
              aria-label={`Vai a ${dish.name}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={dish.img}
                  alt={dish.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
                <span className="absolute top-5 left-5 inline-flex items-center px-3 py-1 rounded-full bg-black/60 backdrop-blur-md border border-white/10 text-[10px] uppercase tracking-[0.18em] text-gold">
                  {dish.tag}
                </span>
                {/* Hover CTA overlay */}
                <div className="absolute top-5 right-5 w-10 h-10 rounded-full grid place-items-center bg-ember/90 opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300">
                  <ArrowRight size={16} className="text-white" />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h3 className="font-display text-2xl md:text-3xl font-semibold text-white">
                  {dish.name}
                </h3>
                <p className="mt-3 text-sm md:text-base text-white/70 leading-relaxed max-w-md">
                  {dish.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs text-gold uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Ordina ora <ArrowRight size={11} />
                </span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
